import React, { useState } from "react";
import { Row, Col, Spin, Form, Card, DatePicker, Input } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { connect } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

import MainLayout from "../../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../../components/layouts/enhancement/TopContent";
import cnt from "../../../../services/definedConstant";
import { rightAction } from "../../../../redux/actions";
import {
  labelConfig,
  staticConfig,
  apiConfig,
} from "../../treasuryContractBooking.config";
import { BOM } from "../../../../services/definedMethod";

const RejectContract = (props) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const contractId = location.state;

  const { userData } = props;
  const { session } = userData || {};

  const onFinish = (values) => {
    setIsLoading(true);

    const body = {
      session,
      locale: "en",
      dateFormat: "dd MMMM yyyy",
      rejectedOnDate: values.rejectedOnDate?.format("DD MMMM YYYY"),
      note: values.rejectionReason,
      method: "POST",
    };

    const url = `${apiConfig.GetTreasuryBillContract}/${contractId}/reject`;

    BOM.FetchReqAction(body, url, (err) => {
      if (err) {
        BOM.AlertMsg(
          cnt.DANGER,
          err?.errors?.[0]?.defaultUserMessage ||
            err?.defaultUserMessage ||
            "Failed to reject contract."
        );
        setIsLoading(false);
        return;
      }

      BOM.AlertMsg(cnt.SUCCESS, "Contract rejected successfully.");
      setIsLoading(false);
      navigate(-1);
    });
  };

  return (
    <MainLayout pageItems={staticConfig.managetreasuryBillContract}>
      <TopContent pageTitle={labelConfig.treasuryBillContract} />

      <Spin spinning={isLoading} size="large">
        <div style={{ padding: "24px" }}>
          <Card
            style={{
              boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
              borderRadius: 20,
            }}
          >
    

            <h3 style={{ marginBottom: 4, fontWeight: 600 }}>
              Reject Contract
            </h3>

            <Form layout="vertical" form={form} onFinish={onFinish}>
              {/* Rejected On Date */}
              <Row>
                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={
                      <span>
                        Rejected On Date{" "}
                        <Tooltip title="The date on which this contract is rejected.">
                          <InfoCircleOutlined style={{ marginLeft: 4, color: "#667085" }} />
                        </Tooltip>
                      </span>
                    }
                    name="rejectedOnDate"
                    rules={[
                      { required: true, message: "Rejection date is required" },
                    ]}
                  >
                    <DatePicker
                      style={{ width: "100%", height: 44 }}
                      format="YYYY-MM-DD"
                      placeholder="YYYY-MM-DD"
                    />
                  </Form.Item>
                </Col>
              </Row>

              {/* Rejection Reason */}
              <Row>
                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={
                      <span>
                        Rejection Reason{" "}
                        <Tooltip title="Describe why this contract is being rejected.">
                          <InfoCircleOutlined style={{ marginLeft: 4, color: "#667085" }} />
                        </Tooltip>
                      </span>
                    }
                    name="rejectionReason"
                    rules={[
                      { required: true, message: "Rejection reason is required" },
                      { min: 5, message: "Please provide a more descriptive reason" },
                    ]}
                  >
                    <Input.TextArea
                      rows={4}
                      placeholder="e.g. Incorrect pricing"
                      style={{
                        resize: "none",
                        borderRadius: 8,
                        fontSize: 14,
                        padding: "10px 12px",
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <div style={{ borderTop: "1px solid #EAECF0", margin: "8px 0 20px" }} />

              <Row justify="end">
                <Col>
                  <button
                    type="button"
                    onClick={() => navigate(-1)}
                    style={{
                      height: 44,
                      padding: "0 24px",
                      borderRadius: 8,
                      border: "1px solid #D0D5DD",
                      background: "#fff",
                      color: "#344054",
                      fontWeight: 600,
                      fontSize: 14,
                      cursor: "pointer",
                      marginRight: 12,
                    }}
                  >
                    Back
                  </button>
                  <button
                    type="button"
                    onClick={() => form.submit()}
                    style={{
                      height: 44,
                      padding: "0 24px",
                      borderRadius: 8,
                      border: "1px solid #B42318",
                      background: "#B42318",
                      color: "#fff",
                      fontWeight: 600,
                      fontSize: 14,
                      cursor: "pointer",
                    }}
                  >
                    Reject Contract
                  </button>
                </Col>
              </Row>
              <button type="submit" hidden />
            </Form>
          </Card>
        </div>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  rightBtn: state.RightSideBtn,
  userData: state.AuthenticationData.userData,
});

export default connect(mapStateToProps, { rightAction })(RejectContract);